"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KycLevel = exports.RiskScore = void 0;
var RiskScore;
(function (RiskScore) {
    RiskScore["LOW"] = "LOW";
    /** @deprecated The risk buckets of MEDIUM_LOW will be deprecated in favor of the bucket MEDIUM */
    RiskScore["MEDIUM_LOW"] = "MEDIUM_LOW";
    RiskScore["MEDIUM"] = "MEDIUM";
    /** @deprecated The risk buckets of MEDIUM_HIGH will be deprecated in favor of the bucket MEDIUM */
    RiskScore["MEDIUM_HIGH"] = "MEDIUM_HIGH";
    RiskScore["HIGH"] = "HIGH";
    RiskScore["PASS"] = "PASS";
    RiskScore["FAIL"] = "FAIL";
    RiskScore["NOT_ASSIGNED"] = "NOT_ASSIGNED";
})(RiskScore = exports.RiskScore || (exports.RiskScore = {}));
var KycLevel;
(function (KycLevel) {
    KycLevel["UNSET"] = "UNSET";
    KycLevel["SDD"] = "SDD";
    KycLevel["FDD"] = "FDD";
    KycLevel["EDD"] = "EDD";
    KycLevel["HEDD"] = "HEDD";
    KycLevel["HEDD1"] = "HEDD1";
})(KycLevel = exports.KycLevel || (exports.KycLevel = {}));
//# sourceMappingURL=styx.js.map